import { UseMutationResult } from '@tanstack/react-query'
import { graphql } from 'src/gql'
import { MutateCreateReportBuilderReportMutation, MutateCreateReportBuilderReportMutationVariables } from 'src/gql/graphql'
import { useGraphMutation } from 'src/hooks/useGraphMutation'

const document = graphql(/* graphql */`
  mutation mutateCreateReportBuilderReport($record: CreateOneReportBuilderReportInput!) {
    cat {
      reporting {
        builder {
          report {
            createOne(record: $record) {
              recordId
            }
          }
        }
      }
    }
  }
`)

export type UseMutateCreateReportBuilderReportReturn = UseMutationResult<
MutateCreateReportBuilderReportMutation,
unknown,
MutateCreateReportBuilderReportMutationVariables
>

const useMutateCreateReportBuilderReport = (): UseMutateCreateReportBuilderReportReturn => {
  return useGraphMutation(document)
}

export { useMutateCreateReportBuilderReport, document as mutateCreateReportBuilderReportDocument }
